(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    function initCollectionFilters(form) {
    if (form.dataset.filtersInitialized) return;
    form.dataset.filtersInitialized = 'true';
    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"], select[data-collection-sort]')) form.submit();
    });
  }

  document.querySelectorAll('[data-collection-filter-form]').forEach(initCollectionFilters);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-collection-filter-form]').forEach(initCollectionFilters);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-gallery"] && !Shopify.designMode) return;
  try {
    function initMediaGallery(gallery) {
    if (gallery.dataset.galleryInitialized) return;
    gallery.dataset.galleryInitialized = 'true';
    const main = gallery.querySelector('[data-gallery-main]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const caption = gallery.querySelector('[data-gallery-caption]');
    const availableSizes = new Set((gallery.dataset.variantOptionValues || '').split(','));
    const replacedId = gallery.dataset.replacedMediaId || '';
    const stageQuery = window.matchMedia('(min-width: 750px)');
    const variantGallery = gallery.dataset.variantGallery === 'true';
    let activeId = null;

    if (!main || slides.length === 0) return;

    function visibleSlides() {
      return slides.filter((slide) => !slide.hidden);
    }

    function setVariant(id, value) {
      if (!variantGallery) return;
      const selectedId = String(id || gallery.dataset.initialVariantId || '');
      const selectedValue = String(value || gallery.dataset.initialVariantValue || '');
      const matches = (element) => element.dataset.variantId
        ? element.dataset.variantId === selectedId
        : element.dataset.variantValue === selectedValue;
      slides.forEach((slide) => { slide.hidden = !matches(slide); });
      thumbs.forEach((thumb) => {
        thumb.hidden = !matches(thumb);
        if (thumb.hidden) {
          thumb.classList.remove('is-current');
          thumb.removeAttribute('aria-current');
        }
      });
      dots.forEach((dot) => { dot.hidden = !matches(dot); });
      thumbs.filter((thumb) => !thumb.hidden).forEach((thumb, index) => {
        thumb.setAttribute('aria-label', gallery.dataset.thumbLabelTemplate.replace('__INDEX__', String(index + 1)));
      });
      const count = visibleSlides().length;
      gallery.classList.toggle('media-gallery--with-thumbs', count > 1);
      gallery.querySelector('[data-gallery-thumbs]')?.toggleAttribute('hidden', count < 2);
      gallery.querySelector('[data-gallery-dots]')?.toggleAttribute('hidden', count < 2);
      gallery.dataset.activeVariantValue = selectedValue;
      gallery.dataset.activeVariantId = selectedId;
    }

    function resolve(mediaId) {
      const id = String(mediaId || '');
      const available = visibleSlides();
      // When a DEV photo request replaces the first photograph, variant
      // changes that point at that photograph show the request instead.
      if (replacedId && id === replacedId && available.some((slide) => slide.dataset.mediaId === 'dev-missing')) {
        return 'dev-missing';
      }
      return available.some((slide) => slide.dataset.mediaId === id) ? id : available[0]?.dataset.mediaId;
    }

    function setActive(mediaId) {
      activeId = mediaId;
      slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
      thumbs.forEach((thumb) => {
        const current = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-current', current);
        if (current) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      dots.forEach((dot) => {
        dot.classList.toggle('media-gallery__dot--active', dot.dataset.mediaId === mediaId);
      });
      if (caption) {
        const activeSlide = slides.find((slide) => slide.dataset.mediaId === mediaId);
        const stagedCaption = activeSlide?.dataset.stagedCaption || '';
        if (stagedCaption) {
          caption.hidden = false;
          caption.textContent = stagedCaption;
          return;
        }
        const alt = activeSlide?.dataset.mediaAlt || '';
        const flowerCount = activeSlide?.dataset.stagedCount || alt.match(/(\d+)\s+kwiat/i)?.[1];
        const namedSize = alt.match(/\b(Medium|Grande)\b/i)?.[1];
        const size = flowerCount || namedSize;
        caption.hidden = !size;
        if (size) {
          const label = flowerCount ? `${flowerCount} ${gallery.dataset.flowersSuffix}` : namedSize;
          caption.textContent = availableSizes.has(size) ? label : `${label} - ${gallery.dataset.sizeUnavailable}`;
        } else {
          caption.textContent = '';
        }
      }
    }

    function show(mediaId, instant = false) {
      const id = resolve(mediaId);
      const slide = visibleSlides().find((item) => item.dataset.mediaId === id) || visibleSlides()[0];
      if (!slide) return;
      setActive(slide.dataset.mediaId);
      if (!stageQuery.matches) {
        main.scrollTo({
          left: slide.offsetLeft - slides[0].offsetLeft,
          behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => show(thumb.dataset.mediaId));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const visible = thumbs.filter((item) => item.offsetParent !== null);
        const index = visible.indexOf(thumb);
        const step = event.key === 'ArrowUp' || event.key === 'ArrowLeft' ? -1 : 1;
        const next = visible[(index + step + visible.length) % visible.length];
        if (next) {
          event.preventDefault();
          next.focus();
        }
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (stageQuery.matches) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting && !entry.target.hidden) setActive(entry.target.dataset.mediaId);
          });
        },
        { root: main, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
      gallery.galleryObserver = observer;
    }

    stageQuery.addEventListener?.('change', () => show(activeId || gallery.dataset.initialMediaId, true));

    gallery.addEventListener('variant:change', (event) => {
      if (event.detail) {
        if (event.detail.variant_id) setVariant(event.detail.variant_id, event.detail.variant_option1);
        show(event.detail.featured_media_id, true);
      }
    });

    setVariant(gallery.dataset.initialVariantId, gallery.dataset.initialVariantValue);
    show(gallery.dataset.initialMediaId || slides[0].dataset.mediaId, true);
  }

  document.querySelectorAll('[data-media-gallery]').forEach(initMediaGallery);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-media-gallery]').forEach(initMediaGallery);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-media-gallery]').forEach((gallery) => gallery.galleryObserver?.disconnect());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.LouWishlist) return;

    const storageKey = 'lou:wishlist:v1';
    let handles = [];

    function read() {
      try {
        const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        handles = Array.isArray(saved)
          ? [...new Set(saved.filter((handle) => typeof handle === 'string' && handle.length > 0))]
          : [];
      } catch (error) {
        handles = [];
      }
      return [...handles];
    }

    function write() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles));
      } catch (error) {
        return;
      }
    }

    function sync(scope = document) {
      scope.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        const active = handles.includes(button.dataset.productHandle);
        const label = active ? button.dataset.removeLabel : button.dataset.addLabel;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (label) button.setAttribute('aria-label', label);
        const text = button.querySelector('[data-wishlist-label]');
        if (text && label) text.textContent = label;
      });

      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = String(handles.length);
        count.hidden = handles.length === 0;
      });
    }

    function announce() {
      sync();
      document.dispatchEvent(
        new CustomEvent('lou:wishlist:change', { detail: { handles: [...handles] } })
      );
    }

    function toggle(handle) {
      if (!handle) return;
      if (handles.includes(handle)) {
        handles = handles.filter((savedHandle) => savedHandle !== handle);
      } else {
        handles = [...handles, handle];
      }
      write();
      announce();
    }

    function remove(handle) {
      if (!handles.includes(handle)) return;
      handles = handles.filter((savedHandle) => savedHandle !== handle);
      write();
      announce();
    }

    read();
    window.LouWishlist = {
      getHandles: () => [...handles],
      has: (handle) => handles.includes(handle),
      toggle,
      remove,
      sync,
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(button.dataset.productHandle);
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey) return;
      read();
      announce();
    });

    document.addEventListener('shopify:section:load', (event) => sync(event.target));

    const initialize = () => {
      sync();
      document.dispatchEvent(
        new CustomEvent('lou:wishlist:ready', { detail: { wishlist: window.LouWishlist } })
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
